const styles = {
  FormInput: {
    textTransform: "uppercase",
    borderRadius: "4px",
  },
};
export default styles;
